module.exports = __webpack_public_path__ + "img/Stab_S4.7733a646.svg";